import { Injectable } from '@angular/core';
import { Headers,Http,Response } from "@angular/http";
import 'rxjs/add/operator/map';
import * as emiGlobals from 'app/globals';
import { JwtHelper } from "angular2-jwt";
import { JwtToken } from "app/shared/services/portal-info";
import { Observable } from "rxjs/Observable";

@Injectable()
export class AuthService {

  private jwtUrl= emiGlobals.jwtTokenUrl;
  redirectUrl = "/";
  
  constructor(
    private http: Http,
    private jwtHelper: JwtHelper
  ) { 
     localStorage.removeItem('id_token');
    console.info("Auth service acticated");
  }
  getJwtToken():Observable<any> {
    return this.http
      .get(this.jwtUrl)
      .catch(this.handleError);
  }
  
  public isInvalidJwtToken() {
    var token = localStorage.getItem('id_token');
    if(token!=null&&!this.jwtHelper.isTokenExpired(token)){
      // console.log(
      //   this.jwtHelper.decodeToken(token),
      //   this.jwtHelper.getTokenExpirationDate(token),
      //   this.jwtHelper.isTokenExpired(token)
      // );
      return false;
    }
    return true;
  }

  public printJwtToken() {
  
    if(localStorage.getItem('id_token')){
      var token = localStorage.getItem('id_token');
      console.log(
        this.jwtHelper.decodeToken(token),
        this.jwtHelper.getTokenExpirationDate(token),
        this.jwtHelper.isTokenExpired(token)
      );
    }else{
       console.log("No token");
    }
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); 
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/auth.service.ts